import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import { parseChannelKey } from '../../utility/channelUtils';
import { formatTimestampToFullDate } from '../../utility/DateUtility';

const mapApiChannelToTableRow = (apiChannel, displayOptions, getDevice, getTargetSensor) => {
  const {
    channelId,
    channelKey,
    alertCount,
    lastSampleTimestamp,
    lastSampleValue,
  } = apiChannel;
  const { scale, timeZone, airSpeedScale } = displayOptions || {};

  const {
    deviceMacAddress,
    channelGroupType,
    channelType,
    channelIndex,
    channelGroupIndex,
  } = parseChannelKey(channelKey);

  const device = getDevice(deviceMacAddress);
  const channelGroup = ChannelService.getChannelGroupTypeByValueId(channelGroupType);
  const port = ChannelService.getChannelGroupPortName(channelGroupType, channelGroupIndex);
  const channelImpl = ChannelService.getChannelGroupChannel(
    channelGroupType,
    channelIndex,
    channelType,
  );

  const deviceName = (device && device.name) || 'Unknown Device';
  const targetSensor = getTargetSensor(channelKey);
  const sensorChannel = channelImpl.displayName || 'Unknown';
  const sensorType = channelGroup.displayName || 'Unknown';
  const sensorName = (targetSensor && targetSensor.label) || 'Unknown Sensor';

  const lastReadingDisplay = channelImpl.getDisplayValueWithUnits(
    lastSampleValue,
    { scale, airSpeedScale },
  );

  const lastReceivedDisplay = formatTimestampToFullDate(lastSampleTimestamp / 1000, timeZone);

  const deviceTypeDisplay = (device && device.type) || 'Unknown device type';
  return {
    channelKey,
    sensorName,
    componentName: apiChannel.componentName || '',
    sensorType,
    sensorChannel,
    port,
    deviceName,
    lastReading: lastReadingDisplay,
    lastReceived: lastReceivedDisplay,
    deviceType: deviceTypeDisplay,
    macAddress: deviceMacAddress,
    serialNumber: deviceMacAddress,
    channelType: channelImpl ? channelImpl.channelType.id : -1,
    readingType: channelImpl ? channelImpl.readingType.id : -1,
    alertCount,
    channelId,
    channelName: channelImpl ? channelImpl.displayName : '',
  };
};

// eslint-disable-next-line import/prefer-default-export
export { mapApiChannelToTableRow };
